import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from '../../../../services/authentication.service';
import { VisitVehicle } from '../../../visit-vehicles/models/visit-vehicle.entity';
import { VisitVehicleService } from '../../../visit-vehicles/services/visit-vehicle.service';

/**
 * Dialog data
 */
export interface DialogData {
  /**
   * Vehicle
   */
  visitVehicleId: string;
}

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditVisitDialogComponent implements OnInit {
  /**
   * Visit Vehicle form
   */
  visitVehicleForm: FormGroup;

  /**
   * Visit Vehicle
   */
  visitVehicle: VisitVehicle;

  booleanValues: any = [
    { id: true, description: 'Si' },
    { id: false, description: 'No' },
  ];

  constructor(
    public dialogRef: MatDialogRef<EditVisitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private visitVehicleService: VisitVehicleService,
    private authService: AuthenticationService
  ) {}
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.visitVehicleForm = new FormGroup({
      timePermitVisitHours: new FormControl(4),
      timePermitVisitMinutes: new FormControl(0),
      idCard: new FormControl('', [this.idCardValidator, Validators.maxLength(16)]),
      timePermitVisit: new FormControl(null),
      description: new FormControl(null, Validators.maxLength(32)),
      visitor: new FormControl(null, Validators.maxLength(32)),
      visited: new FormControl(null, Validators.maxLength(32)),
    });

    this.visitVehicle = new VisitVehicle();
    this.visitVehicleForm.controls.timePermitVisitHours.setValue(4);
    this.visitVehicleForm.controls.timePermitVisitMinutes.setValue(0);
  }

  /**
   * Save visit vehicle form
   */

  save(): void {
    console.log('Salta la función save()');
    // tslint:disable-next-line:max-line-length
    this.visitVehicleForm.controls.timePermitVisit.setValue(
      parseInt(this.visitVehicleForm.controls.timePermitVisitHours.value) * 60 + parseInt(this.visitVehicleForm.controls.timePermitVisitMinutes.value)
    );
    this.visitVehicleForm.removeControl('timePermitVisitHours');
    this.visitVehicleForm.removeControl('timePermitVisitMinutes');
    for (const i in this.visitVehicleForm.controls) {
      if (this.visitVehicleForm.controls.hasOwnProperty(i) && this.visitVehicleForm.controls[i].value !== null) {
        this.visitVehicle[i] = this.visitVehicleForm.controls[i].value;
      }
    }
    this.visitVehicle.initialEntryDate = new Date();
    this.visitVehicle.initialEntryDate.setHours(0);
    this.visitVehicle.initialEntryDate.setMinutes(0);
    this.visitVehicle.initialEntryDate.setSeconds(0);
    this.visitVehicle.authorized = true;
    this.visitVehicle.situation = 1;
    this.visitVehicle.userAuthorization = this.authService.currentUser.name;
    this.visitVehicle.authorizationDate = new Date();
    this.visitVehicle.plate = this.data.toString();
    this.visitVehicle.permissionType = 0;

    this.visitVehicleService.create(this.visitVehicle).subscribe(() => this.close());
  }

  idCardValidator(control: AbstractControl): { [key: string]: boolean } | null {
    let numero: any;
    let letra: any;
    let tmpLetra: any;
    const expresionRegularDni = /^[XYZ]?\d{5,8}[A-Z]$/;
    if (!control.value) {
      return null;
    }
    let dni = control.value;
    dni = dni.toUpperCase();

    if (expresionRegularDni.test(dni) === true) {
      numero = dni.substr(0, dni.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      tmpLetra = dni.substr(dni.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);
      if (letra !== tmpLetra) {
        return { dniInvalid: true };
      } else {
        return null;
      }
    } else {
      return { dniInvalid: true };
    }
  }

  /**
   * Close dialog
   */
  close(): void {
    this.dialogRef.close(this.data);
  }
}
